import { CircleCheck } from "lucide-react";
import { Card } from "../../../shared/card/card.tsx";
import pageStyles from "../../../../pages/onboard-pre-join/create-employee-page.module.css";
import { useSqeOnboardingApi } from "../sqe/sqe-onboarding-link-context.tsx";
import styles from "./submission-success.module.css";

export function SubmissionSuccessPage() {
  const isSqe = useSqeOnboardingApi();
  return (
    <div className={pageStyles.page} data-theme="caelius-classic">
      <header className={pageStyles.topBar}>
        <img className={`${pageStyles.logo} ${isSqe ? pageStyles.sqeLogo : ""}`.trim()} src={isSqe ? "/assets/sqe-login/sqe_logo.svg" : "/assets/images/logo.svg"} alt={isSqe ? "SQE Labs" : "Caelius Consulting"} width={isSqe ? 110 : 150} />
      </header>
      <main className={pageStyles.main}>
        <div className={pageStyles.inner}>
          <Card variant="subtle" padding="5xl">
            <div role="status" className={styles.message}>
              <CircleCheck size={88} strokeWidth={1.35} className={styles.icon} aria-hidden />
              <h2 className="heading-lg">Thank you!</h2>
              <p className="body-sm">Your submission has been sent successfully.</p>
            </div>
          </Card>
        </div>
      </main>
    </div>
  );
}
